/**
 * Drawer theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/drawer.ts
 */
import { drawerAnatomy as parts } from '@chakra-ui/anatomy';
import { DRAG_DRAWER_CONTENT_CLASS_NAME } from '../constants';
import { textStyles } from '../textStyles';
import { ModalBackground } from '../utils/ModalBackground';
import { viewportHeightVariable } from '../utils/useInjectedCssVarOfViewport';
const drawContentSelector = `&.${DRAG_DRAWER_CONTENT_CLASS_NAME}`;
export const Drawer = {
    parts: parts.keys,
    baseStyle(props) {
        return {
            dialog: {
                ...(props.isFullHeight && fullStyles),
                bg: 'brand.background-black',
                borderRadius: '10px 10px 0px 0px',
                overflow: 'hidden',
                background: ModalBackground,
            },
            overlay: {
                // show overlay on top of parent modal
                zIndex: '1400',
                bg: 'rgba(0, 0, 0, 0.6)',
            },
            header: {
                ...textStyles.body1Bold,
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                textTransform: 'capitalize',
                pt: '24px',
                px: '20px',
                pb: '16px',
            },
            footer: {
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'stretch',
            },
            body: {
                pt: '0px',
                px: '20px',
                pb: '24px',
            },
            closeButton: {
                top: '25px',
                right: '20px',
            },
        };
    },
    sizes: {
        full() {
            return {
                dialog: {
                    ...fullStyles,
                    /**
                     * add some space at top of drag drawer
                     */
                    [drawContentSelector]: {
                        height: `calc(${fullStyles.height} - 30px)`,
                    },
                },
            };
        },
    },
    defaultProps: {},
};
/**
 * Fix missing modal footer on iOS.
 * @see https://github.com/chakra-ui/chakra-ui/issues/4903
 */
const fullStyles = {
    minHeight: 'auto',
    maxHeight: 'unset',
    height: `var(${viewportHeightVariable}, -webkit-fill-available)`,
};
